import { EntitySwitch, isKind } from '@backstage/plugin-catalog';

import {
  AiResourceEntityPage,
  ApiEntityPage,
  ComponentEntityPage,
  DefaultEntityPage,
  DomainEntityPage,
  GroupEntityPage,
  SystemEntityPage,
  TemplateEntityPage,
  UserEntityPage,
} from './EntityPages';

export const EntityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')}>{ComponentEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('api')}>{ApiEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('group')}>{GroupEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('user')}>{UserEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('system')}>{SystemEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('domain')}>{DomainEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('template')}>{TemplateEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('airesource')}>{AiResourceEntityPage}</EntitySwitch.Case>

    <EntitySwitch.Case>{DefaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
